module.exports = __webpack_public_path__ + "img/horizontal_6_2_0.b567fc6d.png";